import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import DashboardList from "../../Components/Layouts/DashboardList";
import { permanentDeleteEntity, getDeletedList, restoretDeleteEntity} from "../../Redux/Itinerary/actions";



function DeletedList({ useAuth, getList, list, onDelete, onRestore}) {
  const tableConfig = {
    title: "Deleted Itineraries",
    filterOptionTitle: "Team Type",
    filterOptions: [
      "package",
    ],
    applyFilter: false,
    tableColumns: [
      {name: "Status", selector: 'status', width: '3%'},
      //{name: "Order", selector: 'order', width: '3%'},
      {name: "Title", selector: 'itinerary_title', width: '70%'},
      {name: "Modified Date", selector: 'updated_at', width: '20%'},
      {name: "ID", selector: 'id', width: '5%'}
    ],
    filterByColumn: 'title',
    searchByColumn: 'title',
    updatePath: "/itinerary/update", 
    addPath: "/itinerary/add",
    noDataMessage: "No Itinerary exists",
    updateLinkColumn: 'itinerary_title',
    deleteBtnText: 'Permanent Delete',
    deleteItemsByIdList: (idList) => {
      onDelete(idList)
    },
    restoreItemsByIdList: (idList) => {
      onRestore(idList)
    },
  }

  return (
    <DashboardList
      useAuth={useAuth}
      getList={getList}
      dataToList={list}
      tableConfig={tableConfig}
    />
  );
}


const mapStateToProps = (state) => {
  return {
    list: state.itineraries,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (tokenData) => dispatch(getDeletedList(tokenData)),
    onDelete: (idList) => dispatch(permanentDeleteEntity(idList)),
    onRestore: (idList) => dispatch(restoretDeleteEntity(idList))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletedList);
